import { atom } from "recoil";

const showBackBtnAtom = atom({
    key: 'showBackBtn',
    default: false
})

export default showBackBtnAtom